import React, { useState } from "react";
import MultiStepLayout from "../components/MultiStepLayout";
import Input from "../components/Input";
import PhoneNumberInput2 from "../components/PhoneNumberInput2";
import Dropdown from "../components/Dropdown";
import Button from "../components/Button";
import Textarea from "../components/Textarea";
import Divider from "../icons/Divider";
import PoweredBy from "../components/PoweredBy";
import { useTranslation } from "react-i18next";
import AutoComplete from "../components/AutoComplete";
import ReCAPTCHA from "react-google-recaptcha-enterprise";
import { createPortal } from 'react-dom';

function Step1({
  leadForm,
  lead,
  onChange,
  onBlur,
  step1Valid,
  submitStep1,
  submitting,
  countryCode,
  isMobile,
  geoLocation,
  activeElement,
  setActiveElement,
}) {
  const { t } = useTranslation();

  const bodyClick = (e) => {
    if (e.target.nodeName === "DIV") {
      setActiveElement(null);
    }
  }

  const recaptchaRef = React.createRef();

  const validateRecaptcha = async () => {
    const token = await recaptchaRef.current.execute();
    lead.recaptchaToken = token;
    submitStep1();
  };

  return (
    <MultiStepLayout
      backgroundColor={leadForm.backgroundColor}
      foregroundColor={leadForm.titleColor}
      formBackgroundColor={leadForm.formBackgroundColor}
      isMobile={isMobile}
      className="py-6"
    >
      <div className="text-2xl font-bold mx-0 mb-8 text-center" onClick={(e) => bodyClick(e)}>
        {leadForm.title}
      </div>
      {createPortal(
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        />, document.body
      )}
      <div className={`bodyClick flex gap-6 ${isMobile ? "flex-col" : "flex-row"}`} onClick={(e) => bodyClick(e)}>
        <div className={`flex flex-col gap-6 ${isMobile ? "w-1/1" : "w-1/2"}`}>
          <Input
            label={t("your_name")}
            error={lead.errors.fullName}
            field_name="fullName"
            value={lead.fullName}
            required={true}
            onChange={onChange}
            onBlur={onBlur}
            type="text"
            borderColor={leadForm.inputBorderColor}
            setActiveElement={setActiveElement}
          />
          <Input
            label={t("email")}
            field_name="email"
            error={lead.errors.email}
            value={lead.email}
            required={true}
            onChange={onChange}
            onBlur={onBlur}
            type="text"
            borderColor={leadForm.inputBorderColor}
            setActiveElement={setActiveElement}
          />
          <PhoneNumberInput2
            label={t("phone_number")}
            field_name="phoneNumber"
            countryCode={countryCode}
            error={lead.errors.phoneNumber}
            value={lead.phoneNumber}
            required={true}
            onBlur={onBlur}
            onChange={onChange}
            borderColor={leadForm.inputBorderColor}
            geoLocation={geoLocation}
            setActiveElement={setActiveElement}
          />
          <div className={`mt-auto mr-auto ${isMobile ? "hidden" : "block"}`}>
            <PoweredBy backgroundColor={leadForm.formBackgroundColor} />
          </div>
        </div>
        <div
          className={`w-full flex justify-center ${isMobile ? "" : "hidden"}`}
        >
          <Divider />
        </div>
        <div className={`flex flex-col gap-6 ${isMobile ? "w-1/1" : "w-1/2"}`}>
          <AutoComplete
            position="auto"
            label={t("primary_treatment")}
            error={lead.errors.procedure}
            field_name="procedure"
            value={lead.procedure}
            required={true}
            onChange={onChange}
            onBlur={onBlur}
            values={leadForm.procedures}
            borderColor={leadForm.inputBorderColor}
            activeElement={activeElement}
            setActiveElement={setActiveElement}
          />
          <Dropdown
            position="auto"
            label={t("preferred_language")}
            field_name="language"
            error={lead.errors.language}
            value={lead.language}
            required={true}
            onChange={onChange}
            onBlur={onBlur}
            values={leadForm.languages}
            borderColor={leadForm.inputBorderColor}
            activeElement={activeElement}
            setActiveElement={setActiveElement}
          />
          <Textarea
            label={t("additional_information")}
            field_name="notes"
            value={lead.notes}
            required={false}
            onChange={onChange}
            onBlur={onBlur}
            borderColor={leadForm.inputBorderColor}
            setActiveElement={setActiveElement}
          />
          <Button
            title={leadForm.submitText}
            backgroundColor={leadForm.submitBackgroundColor}
            color={leadForm.submitColor}
            active={step1Valid && !submitting}
            onClick={validateRecaptcha}
          />
        </div>

        <div
          className={`w-full flex justify-center ${isMobile ? "" : "hidden"}`}
        >
          <PoweredBy backgroundColor={leadForm.formBackgroundColor} />
        </div>
      </div>
    </MultiStepLayout>
  );
}

export default Step1;
